import { Settings } from "../../../Settings";
import NumberFormatter from "../../../util/NumberFormatter";
import Totals from "../../crew/Totals";
import NumberValue from "../../value/NumberValue";
import NumberValueSkillNode from "../common/NumberValueSkillNode";

export default class UpgradeAutomationSkillNode extends NumberValueSkillNode {
    /**
     * @param {string} id 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {NumberValue} automationRateUpgrades
     */
    constructor(id, totals, iconFileName, cost, purchaseListener, automationRateUpgrades) {
        super(id, 'Delay -' + Settings.automation.secondsPerRateUpgrade + ' sec', null, totals, 
            iconFileName, cost, purchaseListener, 1, automationRateUpgrades);
    }

    /**
     * @returns {string}
     */
    getDescription() {

        let delayTurns = Settings.automation.baseUpgradeDelayTurns;
        let discountTurns = Settings.automation.turnsPerRateUpgrade * this.numberValue.getValue();

        let turns = Math.max(Settings.automation.minDelayTurns, delayTurns - discountTurns);

        return 'Current Delay: ' + NumberFormatter.formatNumber(turns * Settings.time.secondsPerTurn) + 's';
    }

}